export default "__VITE_ASSET__bsGllAp0__"